/**
 * @generated SignedSource<<364aace1d6bdeb507e6c5922fc6a6538>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSourceOfFundsToCommonFormatRequiredData$data = {
  readonly userProperties: {
    readonly country: {
      readonly code: string;
    } | null;
    readonly showInstantAchUx: boolean | null;
  };
  readonly " $fragmentType": "useSourceOfFundsToCommonFormatRequiredData";
};
export type useSourceOfFundsToCommonFormatRequiredData$key = {
  readonly " $data"?: useSourceOfFundsToCommonFormatRequiredData$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSourceOfFundsToCommonFormatRequiredData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSourceOfFundsToCommonFormatRequiredData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProperties",
      "kind": "LinkedField",
      "name": "userProperties",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Country",
          "kind": "LinkedField",
          "name": "country",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showInstantAchUx",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "23d6ba2905eb0b17d6d4505f7b36b9c6";

export default node;
